module.exports = __webpack_public_path__ + "img/jpeg-image.524200f0.png";